/**
 * Vision Slide
 * The Home CEO - AI for Moms Managing Their Households
 * Uses the same calm water background as the landing page, but much lighter
 */

import React from 'react';
import styled from 'styled-components';
import { colors } from '@config/colors';
import { typography } from '@config/typography';
import { LANDING_BACKGROUND_URL, LANDING_BACKGROUND_ASSET_NAME } from '@config/critical-assets';
import { useMediaAsset } from '@hooks/use-media-asset';
import { PulsingHomeIcon } from '@components/icons/pulsing-home-icon';
import {
  HeaderSlideBase,
  SlideContent,
  HeroTitle,
  HeroSubtitle,
  DarkAccentBox,
  DarkCardBody,
} from '@components/press/pitch-deck/slide-primitives';

const VisionBackground = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.5;
  pointer-events: none;
`;

/** Extra vertical breathing room around the icon when space allows */
const IconSpacer = styled.div`
  margin: clamp(0px, 2vh, 24px) 0;
`;

const VisionBox = styled(DarkAccentBox)`
  max-width: 720px;
  width: 100%;
`;

const VisionStatement = styled(DarkCardBody)`
  font-size: clamp(${typography.fontSize.sm}, 1.6vw, ${typography.fontSize.lg});
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
`;

const CoralHighlight = styled.span`
  color: ${colors.accent.coral.extraDark};
`;

export const VisionSlide: React.FC = () => {
  const { url: backgroundUrl } = useMediaAsset(LANDING_BACKGROUND_ASSET_NAME, LANDING_BACKGROUND_URL);

  return (
  <HeaderSlideBase>
    {backgroundUrl && <VisionBackground src={backgroundUrl} alt="" />}
    <SlideContent>
      <HeroTitle>The Home CEO</HeroTitle>
      <IconSpacer>
        <PulsingHomeIcon size={80} />
      </IconSpacer>
      <VisionBox>
      <HeroSubtitle><CoralHighlight>AI for Moms Managing Their Households</CoralHighlight></HeroSubtitle>
        <VisionStatement>
          <br /><br />
          Moms need help with the invisible labor behind <br /><CoralHighlight>kids, homes, cars, pets</CoralHighlight> and <CoralHighlight>date nights</CoralHighlight>
          <br />&mdash;<br />
          AI will be a critical tool for moms to go from surviving to thriving, <br />
          unlocking a <CoralHighlight>higher quality of life</CoralHighlight> for families
        </VisionStatement>
      </VisionBox>
    </SlideContent>
  </HeaderSlideBase>
  );
};
